(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-shortcut"]) return;
  try {
    
  setTimeout(function(){
	if ($('.collection-list-shortcut a').length == 0) $('.collection-list-shortcut').remove();
	$('.collection-list-shortcut').addClass('ready');
    $('.collection-list-shortcut').flickity('resize');
    setTimeout(function(){
      $('.collection-list-shortcut').flickity('resize');
      setTimeout(function(){
        $('.collection-list-shortcut').flickity('resize');
      }, 500);
    }, 500);
  }, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fw22"]) return;
  try {
    
  $(document).ready(function(){
  	var optionsSliderfw22 = {groupCells:true,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:false,selectedAttraction:.08,friction:.6,lazyLoad:1};
	$(".collection-fw22 .slider-fw22").flickity(optionsSliderfw22);
	if (matchMedia('screen and (min-width: 768px)').matches) optionsSliderfw22.groupCells = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-spring22"]) return;
  try {
    
  $(document).ready(function(){
  	var optionsSliderSpring22 = {groupCells:true,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:false,selectedAttraction:.08,friction:.6,lazyLoad:1};
	$(".collection-spring22 .slider-spring22").flickity(optionsSliderSpring22);
	if (matchMedia('screen and (min-width: 768px)').matches) optionsSliderSpring22.groupCells = false;
  });

  } catch(e) { console.error(e); }
})();
})();
